import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

const rootElement = document.getElementById("root")!;
if (rootElement.hasChildNodes()) {
    <HelmetProvider>
        <App />
    </HelmetProvider>
} else {
    createRoot(rootElement).render(
        <HelmetProvider>
            <App />
        </HelmetProvider>
    );
}
